import React from "react"

const About = () => {
  return (
    <div style={{ padding: "10px" }}>
      <p>
        <b>Application Name-</b> Issue Tracker
      </p>
      <p>
        <b>Front End-</b>
      </p>
      <ul>
        <li>React JS</li>
        <li>Material UI</li>
        <li>Redux</li>
        <li>React Router</li>
      </ul>
      <p>
        <b>Testing-</b>
      </p>
      <ul>
        <li>Jest JS</li>
        <li>Enzyme</li>
      </ul>
      <p>
        <b>Back End-</b>
      </p>
      <ul>
        <li>JSON Server</li>
      </ul>
      <p>
        <b>Features/Functionality-</b>
      </p>
      <ul>
        <li>View all issues and filter them without logging in</li>
        <li>Sign up to Add or Edit a issue</li>
        <li>After logging in you can Add, View, Edit, Delete issues</li>
        <li>Customize the fields you want to view</li>
        <li>Manage issues in 2 views- Grid View and List View</li>
        <li>View chart of all the issues, severity and status wise</li>
        <li>Apply search filter on description, status and severity</li>
        <li>and many more...</li>
      </ul>
      <p>
        <b>Design and Developed by-</b>
      </p>
      <p>Yash Patni</p>
      <a href="mailto:yash.s.patni@gmail.com" target="_blank" rel="noreferrer">
        yash.s.patni@gmail.com
      </a>
    </div>
  )
}

export default About
